import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Avatar from 'react-avatar';
import React, { useContext, useState, useReducer, useLayoutEffect, useEffect } from 'react';
import { Store } from '../../Store';
import './AdminNavbar.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { RxCross1 } from 'react-icons/rx';
import AdminNavbarOptions from '../AdminNavbarOptions/AdminNavbarOptions';
import NavbarToggler from '../NavbarToggler/NavbarToggler';
import AdminFooter from '../AdminFooter/AdminFooter';
import { isAdminPath } from '../../routes/paths';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import settingsService from '../../services/settings.service';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_COMPANY_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_COMPANY_SUCCESS':
      return {
        ...state,
        companyName: action.payload.companyName,
        loading: false,
      };
    case 'FETCH_COMPANY_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

function AdminNavbar() {
  const { t } = useTranslation();
  const [{ companyName }, dispatch] = useReducer(reducer, {
    companyName: '',
    loading: false,
    error: '',
  });

  const [isScrolled, setIsScrolled] = useState();
  const [currentTitle, setCurrentTitle] = useState('');
  const [isActiveCollapse, setActiveCollapse] = useState(false);

  const fetchData = async () => {
    try {
      dispatch({ type: 'FETCH_COMPANY_REQUEST' });
      const data = await settingsService.getPublicSettings();
      dispatch({ type: 'FETCH_COMPANY_SUCCESS', payload: data });
    } catch (err) {
      dispatch({ type: 'FETCH_COMPANY_FAIL', payload: err.message });
    }
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setActiveCollapse(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    fetchData();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        const sectionTitle = document.querySelector('.section-title');
        setIsScrolled(true);
        setCurrentTitle(sectionTitle ? sectionTitle.textContent : '');
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const { state: contextState, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = contextState;
  const navigate = useNavigate();

  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    navigate('/signin');
  };

  const handleToggleCollapse = () => {
    setActiveCollapse(!isActiveCollapse);
  };
  const handleCloseCollapse = () => {
    setActiveCollapse(false);
  };
  const location = useLocation();
  const route = location.pathname;
  if (!isAdminPath(route)) return null;

  return (
    <div>
      <ToastContainer position='bottom-center' limit={1}></ToastContainer>
      <header className='header-admin'>
        <div className='container-fluid admin-navbar'>
          <NavbarToggler onClick={handleToggleCollapse} className='admin-toggler' />
          <div className={`navbar-collapse-Admin ${isActiveCollapse ? 'open' : ''}`}>
            {!isActiveCollapse ? (
              <div className='d-flex h-100 w-100 flex-column flex-wrap justify-content-between'>
                <AdminNavbarOptions companyName={companyName} Collapse={handleCloseCollapse} />
                <AdminFooter companyName={companyName} />
              </div>
            ) : (
              <Modal
                backdropClassName='collapsable-navbar-backdrop'
                show={isActiveCollapse}
                dialogClassName='collapsable-navbar-extended'
                onHide={handleCloseCollapse}
              >
                <Row className='justify-content-end mt-3 w-100'>
                  <button
                    className='col-md-1 col-sm-2 col-3 exit-menu'
                    onClick={handleCloseCollapse}
                  >
                    <RxCross1 />
                  </button>
                </Row>
                <AdminNavbarOptions Collapse={handleCloseCollapse} />
              </Modal>
            )}
          </div>
          <div className='admin-navbar-right'>
            <div className={classnames('admin-nav-title', { show: isScrolled })}>
              {' '}
              {currentTitle}
            </div>
            <div className='d-flex align-items-center'>
              {userInfo ? (
                <NavDropdown
                  title={
                    <Avatar
                      fgColor=''
                      size='35px'
                      textSizeRatio={2}
                      color='rgba(4,30,73,0.7)'
                      name={userInfo ? userInfo.nombre : ''}
                    />
                  }
                  drop='down'
                  id='basic-nav-dropdown'
                >
                  <NavDropdown.Item as={Link} to='/profile'>
                    {t('auth.myProfile')}
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={signoutHandler}>
                    <i className='fa fa-sign-out' aria-hidden='true'></i>
                    <span>{t('auth.signOut')}</span>
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <Link className='nav-link' to='/signin'>
                  <i className='fa fa-user' aria-hidden='true'></i>
                  <span className='d-none d-lg-block'>{t('auth.signIn')}</span>
                </Link>
              )}
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default AdminNavbar;
